<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <input class="form-select" v-model="item.from.category" :columns="3" readonly="readonly">
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <div class="l-col-6@md">
      <div class="l-row">
        <form-group :label="`${$t('category.label')} ${$t('level.label')} ${(index + 1)}`" :columns="6" v-for="(category, index) in item.to.categories" :key="category">
          <input class="form-select" v-model="category.name" readonly="readonly">
        </form-group>
      </div>
    </div>

    <div class="l-col-2@md vertical-center">
      <slot/>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      itemsNames: {},
      doneFilling: false,
      categoryNotFound: false
    }),
    props: {
      preset: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    components: {
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px

  .icon-category-not-found
    margin: 5px 0 0 16px

    i
      font-size: 24px
</style>



// WEBPACK FOOTER //
// CategorizationItem.vue?772251a2